import React from "react";
import { Label } from "semantic-ui-react";

const PermitFormStackedLabel = ({ customFieldName, staffOnly }: { customFieldName: string; staffOnly: boolean }) => (
  <div className='tw-flex tw-items-start tw-gap-2'>
    <div>{customFieldName}</div>
    {staffOnly && (
      <div className='tw-h-2'>
        <Label className='tw--mt-4' circular color='grey' floated='right' size='small'>
          Staff Only
        </Label>
      </div>
    )}
  </div>
);

export default PermitFormStackedLabel;
